import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiClientConfig } from './api-client-config';
import {
  ChatbotSendSectionReactionRequest
} from 'it/primatoo/openapi/api/org/schemas/chatbot/ChatbotSendSectionReactionRequest';
import { ChatbotSendReactionRequest } from 'it/primatoo/openapi/api/org/schemas/chatbot/ChatbotSendReactionRequest';
import { ChatbotAskQuestionRequest } from 'it/primatoo/openapi/api/org/schemas/chatbot/ChatbotAskQuestionRequest';
import { ChatbotAskQuestionResponse } from 'it/primatoo/openapi/api/org/schemas/chatbot/ChatbotAskQuestionResponse';

@Injectable({
  providedIn: 'root'
})
export class ChatbotService {
  private readonly endpoint: string;

  constructor(@Inject(ApiClientConfig) private config,
              private httpClient: HttpClient) {
    this.endpoint = this.config.endPoint + '/api/org/v2/chatbot/';

  }

  public sendSectionReaction(uuid: string, reaction: ChatbotSendSectionReactionRequest): Observable<void> {
    const url = this.endpoint + `${uuid}/send-section-reaction`;
    return this.httpClient.post<void>(url, reaction);
  }

  public sendReaction(uuid: string, reaction: ChatbotSendReactionRequest): Observable<void> {
    const url = this.endpoint + `${uuid}/send-reaction`;
    return this.httpClient.post<void>(url, reaction);
  }

  public askQuestion(reaction: ChatbotAskQuestionRequest): Observable<ChatbotAskQuestionResponse> {
    const url = this.endpoint + `ask-question`;
    return this.httpClient.post<ChatbotAskQuestionResponse>(url, reaction);
  }

}
